export function getViewDimensionsState() {
  if (!(document && window)) return {};
  return {
    viewWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
    viewHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
  };
}

export function getInjectAds(props) {
  const {
    injectAds,
    breakpoint,
  } = props;

  if (!injectAds) return null;

  return injectAds[breakpoint];
}

export function getImageAspectRatio(image) {
  const {
    width,
    height,
  } = image.attributes.versions.original;
  return width / height;
}

export function getGalleryAspectRatio(images) {
  // выбираем минимальное соотношение сторон, чтобы получить самую квадратную картинку из горизонтальных
  const imagesAspectRatios = images.map(getImageAspectRatio);
  const minAspectRatio = Math.min(...imagesAspectRatios);
  // если получили galleryAspectRatio < 1, значит есть вертикальные фотки - тогда делаем галерею квадратной
  return minAspectRatio > 1 ? minAspectRatio : 1;
}
